/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import Answer from 'material/embeds/content/shared/answer/answer';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    currentOptionStatus: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(Answer);
